module.exports = __webpack_public_path__ + "83c0771cc66338897dde36cb9f08b63d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/request-center/policies/list/approval-policies-list.html
// module id = 1764
// module chunks = 0